<section class="jumbotron">
  <div class="container position-relative">
    <div class="jumbotron-content text-white text-center">
      <h1 class="font-weight-bolder text-title-header">{{'contact.title' | translate}}</h1>
      <p class="font-weight-bolder">{{'contact.subtitle' | translate}}</p>
    </div>
  </div>
</section>
<section>
  <div class="container py-4">
   <form id="form"  >
    <div class="row">
      <div class="col-12">
        <p><b>{{'contact.yourself' | translate}}</b></p>
      </div>
      <div class="col-lg-4 mb-2">
        <input class="form-control" maxlength="250" id="idNombre" [(ngModel)]="nombreCompleto" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{'contact.fullname' | translate}}" required>
      </div>
      <div class="col-lg-4 mb-2">
        <input class="form-control" maxlength="100"  id="idEmpresa" [(ngModel)]="empresa" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{'contact.company' | translate}}" required>
      </div>
      <div class="col-lg-4 mb-2">
        <div class="form-group">
          <input type="email" id="idEmail" maxlength="50" [(ngModel)]="email" [ngModelOptions]="{standalone: true}"
          [ngClass]="{'is-invalid' : !validateEmail(email)}"
          class="form-control" placeholder="{{'contact.email' | translate}}" required>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4 mb-2">
        <input class="form-control" maxlength="9"  id="idCelular" [(ngModel)]="celular" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{'contact.celular' | translate}}" required>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <p><b>{{'contact.help' | translate}}</b></p>
      </div>
      <div class="col-12 mb-4">
        <select class="form-control" id="subject">
          <option  default selected disabled>{{'contact.subject' | translate}}</option>
          <option  value="{{'contact.op1' | translate}}">{{'contact.op1' | translate}}</option>
          <option  value="{{'contact.op2' | translate}}">{{'contact.op2' | translate}}</option>
          <option  value="{{'contact.op3' | translate}}">{{'contact.op3' | translate}}</option>
          <option  value="{{'contact.op4' | translate}}">{{'contact.op4' | translate}}</option>
          <option  value="{{'contact.op5' | translate}}">{{'contact.op5' | translate}}</option>
          <option  value="{{'contact.op6' | translate}}">{{'contact.op6' | translate}}</option>
          <option  value="{{'contact.op7' | translate}}">{{'contact.op7' | translate}}</option>
          <option  value="{{'contact.op8' | translate}}">{{'contact.op8' | translate}}</option>
        </select>
        <!-- <input class="form-control" id="subject" maxlength="100" [(ngModel)]="subject" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{'contact.subject' | translate}}" required> -->
      </div>
      <div class="col-12 mb-4">
        <textarea rows="5" class="form-control" maxlength="300" id="message" [(ngModel)]="message" [ngModelOptions]="{standalone: true}" type="text" placeholder="{{'contact.message' | translate}}" required> </textarea>
      </div>
      <!-- <div class="col-12 mb-4">
        <div class="g-recaptcha" data-sitekey="6LcgLHMaAAAAALEPF0LoMPEHTHVndP_Qnqnh5Lgu" id="widget"></div>
      </div> -->
     
      <div class="col-12">
        
        <button class="btn custom-cta bg-yellow-qaira mb-5" id="btnSend"
        type="submit" [disabled]="validateFields()" >
        <span
        matTooltip="{{'app.all_fields' | translate}}"  [matTooltipDisabled]="!validateFields()"
        matTooltipPosition="right"
        >
        {{'contact.send_message' | translate}}
        </span>
      </button>
      <br/>
      </div>
    </div>
   </form>
  </div>
</section>
    <!-- Then put toasts within -->

    <div class="toast d-flex align-items-center text-white bg-primary border-0" role="alert" aria-live="assertive" aria-atomic="true"
    data-bs-delay="5000">
    <div class="toast-body">
      {{'app.sent_message' | translate}}
    </div>
    <button type="button" class="close" data-dismiss="toast" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
